import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { cancelCellEdit } from '../../actions/grid-screen';
import { updatePhraseBidRemote } from '../../actions/phrases-grid';
import {
    PhraseContextMoneyCellEditorProps,
    PhraseContextMoneyEditor
} from '../../components/PhraseContextMoneyEditor/PhraseContextMoneyEditor';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { ConstData } from '../../typings/constants';
import { CoverageByPriceData } from '../../typings/domain';
import { CurrencyCode } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

export type StateProps = Pick<
    PhraseContextMoneyCellEditorProps,
    'isSaving' | 'error' | 'priceLimit'
>;

export interface DispatchProps {
    onSave: (value: number) => void;
    onCancel: () => void;
}

export type OwnProps = {
    id: string;
    cls?: string;
    groupId: string;
    cellName: string;
    currency: CurrencyCode;
    priceContext?: number;
    priceForCoverage: Array<CoverageByPriceData>;
    constants: ConstData;
    isCpmBanner: boolean;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData } = state.grid;
    const { id, cellName, currency, constants } = ownProps;
    const { view } = selectGridSourceParams(state);
    const {
        minPrice,
        maxPrice,
        bigRate,
        minCpmPrice,
        maxCpmPrice
    } = constants.currencyConstants[currency];

    return {
        priceLimit: {
            minPrice,
            maxPrice,
            minCpmPrice,
            maxCpmPrice,
            bigRate
        },
        ...getEditCellData(editCellsData, id, cellName, view)
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { cellName, id, groupId } = ownProps;

    return {
        onSave: (value: number) => {
            dispatch(
                updatePhraseBidRemote(
                    {
                        id,
                        groupId,
                        exactPriceContext: value
                    },
                    cellName
                )
            );
        },
        onCancel: () => {
            dispatch(cancelCellEdit(id, cellName));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhraseContextMoneyCellEditorProps => {
    const {
        currency,
        priceContext,
        priceForCoverage,
        cls,
        isCpmBanner
    } = ownProps;

    return {
        ...{ currency, priceContext, priceForCoverage, cls, isCpmBanner },
        ...stateProps,
        ...dispatchProps
    };
};

export const PhraseMoneyCellContextEditorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhraseContextMoneyCellEditorProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhraseContextMoneyEditor);
